import { ComponentConstants, math } from '../SavaneJS';
import { Component } from './Component';

export class SmartContentLayer extends Component {

    constructor(id: number) {
        super();
        this._id = id;
        this._isUnique = true;
    }

    clone(): SmartContentLayer {
        let result = new SmartContentLayer(this._id);
        return result;
    }

    get componentType(): ComponentConstants.ComponentType {
        return ComponentConstants.ComponentType.SmartContentLayer;
    }

    get uuid() {
        return this._entity.id;
    }
}
